export default "__VITE_ASSET__741f0a98__"